import React from 'react';
import { useAllImagesQuery } from '../../app/api';

// Image Gallery Component
const ImageGallery = () => {
  const {data: images} = useAllImagesQuery();

/*  
    const handleImageClick = async (image) => {
    try {
      // Return the selected image src directly
      return { src: 'https://ffn-email-design.s3.us-west-2.amazonaws.com/' + image.filename };
    } catch (error) {
      console.error('Error selecting image:', error);
    }
  };
  */

  const imageOverlayStyle = {
    transition: 'all 0.3s ease',
    background: 'rgba(0, 0, 0, 0)',
  };

  const imageWrapperStyle = {
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
  };

  const selectTextStyle = {
    opacity: 0,
    transition: 'opacity 0.3s ease',
  };

  const mclose1 = {
    position: 'absolute',
    top: '5px',
    left: '10px',
    fontSize: '16px',
    cursor: 'pointer'
  };

  return (
    <div id='gallery-modal' className="card p-4 hidden">
      <div id="gallery-modal-close" className="close" style={mclose1}>X</div>
      <div className="container">
        <div className="row g-4">
          {images && images.map((image) => (
            <div key={image.id} className="col-12 col-md-6 col-lg-4">
              <div 
                className="position-relative"
                style={imageWrapperStyle}
                id={image.filename}
                onMouseEnter={(e) => {
                  e.currentTarget.querySelector('.overlay').style.background = 'rgba(0, 0, 0, 0.2)';
                  e.currentTarget.querySelector('.select-text').style.opacity = '1';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.querySelector('.overlay').style.background = 'rgba(0, 0, 0, 0)';
                  e.currentTarget.querySelector('.select-text').style.opacity = '0';
                }}
              >
                <img
                  src={'https://ffn-email-design.s3.us-west-2.amazonaws.com/' + image.filename}
                  className="img-fluid rounded"
                  style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                />
                <div 
                  className="overlay position-absolute top-0 start-0 w-100 h-100"
                  style={imageOverlayStyle}
                />
                <div className="position-absolute top-50 start-50 translate-middle w-100 text-center">
                  <span 
                    className="select-text badge bg-dark bg-opacity-75 px-3 py-2"
                    style={selectTextStyle}
                  >
                    Select Image
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageGallery